// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_u2-0";
export var checkoutRateBadgeLink = "_u2-1";